import React from 'react';
import {DateCell} from "../../../components/common/advance-table/CustomCells";
import {useFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import {useUser} from "../../../hooks/useUser";
import {Card} from "react-bootstrap";
import CardTableHeader from "../../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../../components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../../../components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "../../../components/common/advance-table/AdvanceTableWrapper";
import NewOrganizationAddressModal from "./NewOrganizationAddressModal";
import EditOrganizationAddressModal from "./EditOrganizationAddressModal";
import {useTableModals} from "../../../hooks/useTableModals";
import DeleteModal from "../../../components/common/modals/DeleteModal";

const cols = [
    {
        accessor: "addressUseCode.display",
        Header: "Use"
    },
    {
        accessor:"addressLine1",
        Header: "Address",
        Cell: (rowData) => {
            const address = rowData.row.original
            let addressLine = address.addressLine1
            if(address.addressLine2) {
                addressLine = addressLine + " " + address.addressLine2
            }
            if(address.addressLine3) {
                addressLine = addressLine + " " + address.addressLine3
            }
            return <>{addressLine + " " + address.city + ", " + address.state + " " + address.postalCode}</>
        }
    },
    {
        accessor:"effectiveFrom",
        Header: "Effective From",
        Cell: DateCell
    },
    {
      accessor: "effectiveTo",
      Header: "Effective To",
      Cell: DateCell  
    }
]
const OrganizationAddresses = ({addresses, organizationId, addressUseCodes}) => {
    const data = useFragment(graphql`
    fragment OrganizationAddresses_Addresses on OrganizationAddress @relay(plural: true) {
        id
        addressUseCode {
            id
            display
        }
        addressLine1
        addressLine2
        addressLine3
        city
        state
        postalCode
        longitude
        latitude
        county {
            id
            name
            state
        }
        effectiveFrom,
        effectiveTo
    }`, addresses);
    const {hasPermission} = useUser();
    const {selected, columns, newModal, editModal, deleteModal} = useTableModals(cols, "OrganizationAddress.Update", "OrganizationAddress.Delete");
    const mutation = graphql`
        mutation OrganizationAddressesDeleteMutation($id: ID!) {
            deleteNode(input: {id: $id}) {
                deletedNodeId @deleteRecord
                owner {
                    ... on Organization {
                        id
                        addresses {
                            ...OrganizationAddresses_Addresses
                        }}}}}`
    return (
        <>
            <AdvanceTableWrapper columns={columns}
                                 data={data}
                                 sortable
                                 pagination
                                 perPage={10}
            >
                <Card className={"mb-3"}>
                    <Card.Header>
                        <CardTableHeader onNewClick={newModal.onClick}
                                         title={"Addresses"}
                                         table
                                         showNew={hasPermission("OrganizationAddress.Create")}
                        />
                    </Card.Header>
                    <Card.Body className={"p-0"}>
                        <AdvanceTable table
                                      headerClassName="bg-200 text-900 text-nowrap align-middle"
                                      rowClassName="align-middle white-space-nowrap"
                                      tableProps={{
                                          size: 'sm',
                                          striped: true,
                                          className: 'fs--1 mb-0 overflow-hidden'}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTablePagination table/>
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <NewOrganizationAddressModal onClose={newModal.onClose}
                                         addressUseCodes={addressUseCodes}
                                         showModal={newModal.showModal}
                                         organizationId={organizationId}
            />
            {selected && <EditOrganizationAddressModal showModal={editModal.showModal} 
                                          onClose={editModal.onClose}
                                          selectedAddress={selected}
                                          addressUseCodes={addressUseCodes}
            />}
            {selected && <DeleteModal mutation={mutation} 
                                      onClose={deleteModal.onClose}
                                      thingToDelete={"Address"} 
                                      showModal={deleteModal.showModal}
                                      id={selected.id}
            >
                <p>This cannot be undone.</p>
            </DeleteModal>}
        </>
    )
}
export default OrganizationAddresses